import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuth } from './contexts/AuthContext'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import LoadingSpinner from './components/ui/LoadingSpinner'

// Pages
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ChallengesPage from './pages/ChallengesPage'
import ChallengeDetailPage from './pages/ChallengeDetailPage'
import LeaderboardPage from './pages/LeaderboardPage'
import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import ResetPasswordPage from './pages/auth/ResetPasswordPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import ProfilePage from './pages/dashboard/ProfilePage'
import SubmissionsPage from './pages/dashboard/SubmissionsPage'
import SubmissionDetailPage from './pages/dashboard/SubmissionDetailPage'
import SubmitSolutionPage from './pages/dashboard/SubmitSolutionPage'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AdminRoute from './components/auth/AdminRoute'
import NotFoundPage from './pages/NotFoundPage'
import ShadcnDemo from './components/ShadcnDemo'
import MigrationExample from './components/MigrationExample'

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminChallenges from './pages/admin/AdminChallenges'
import AdminSubmissions from './pages/admin/AdminSubmissions'
import AdminSubmissionDetail from './pages/admin/AdminSubmissionDetail'
import AdminUsers from './pages/admin/AdminUsers'
import CreateChallenge from './pages/admin/CreateChallenge'

function App() {
  const { loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              theme: {
                primary: '#4aed88',
              },
            },
          }}
        />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/challenges" element={<ChallengesPage />} />
          <Route path="/challenges/:id" element={<ChallengeDetailPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/demo" element={<ShadcnDemo />} />
          <Route path="/migration" element={<MigrationExample />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } />
          <Route path="/submissions" element={
            <ProtectedRoute>
              <SubmissionsPage />
            </ProtectedRoute>
          } />
          <Route path="/submissions/:id" element={
            <ProtectedRoute>
              <SubmissionDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/submit/:challengeId" element={
            <ProtectedRoute>
              <SubmitSolutionPage />
            </ProtectedRoute>
          } />

          {/* Admin Routes */}
          <Route path="/admin/dashboard" element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
          <Route path="/admin/challenges" element={
            <AdminRoute>
              <AdminChallenges />
            </AdminRoute>
          } />
          <Route path="/admin/challenges/create" element={
            <AdminRoute>
              <CreateChallenge />
            </AdminRoute>
          } />
          <Route path="/admin/submissions" element={
            <AdminRoute>
              <AdminSubmissions />
            </AdminRoute>
          } />
          <Route path="/admin/submissions/:id" element={
            <AdminRoute>
              <AdminSubmissionDetail />
            </AdminRoute>
          } />
          <Route path="/admin/users" element={
            <AdminRoute>
              <AdminUsers />
            </AdminRoute>
          } />

          {/* 404 Page */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App